import { Model } from "./Model";
import { Place } from "./Place";
import { User } from "./User";
import { Contract } from "./Contract";

export class Task extends Model {
  static props = {
    id: { type: Number },
    scope_item_id: { type: Number },
    work_scope_id: { type: Number },
    work_scope_item_id: { type: Number },
    crew_id: { type: Number },
    contract_id: { type: Number },
    contract: { type: Contract },
    user_id: { type: Number },
    user: { type: User },
    location: { type: Place },
    status: { type: String },
    name: { type: String },
    is_default: { type: Boolean },
    hours_scoped: { type: Number },
    crew_member_hours: { type: Number },
    crew_leader_hours: { type: Number },
    crew_members_present: { type: Number },
    scheduled_for: { type: Date },
    priority: { type: String },
    description: { type: String },
    files: { type: Array, default: [] },
    path: { type: String }
  };

  constructor(parameters) {
    super(Task.props, parameters);
  }

  get crewIdentifier() {
    return this.user && this.user.crew ? this.user.crew.identifier : null;
  }

  get primaryContact() {
    return this.contract && this.contract.primary_contact
      ? this.contract.primary_contact
      : null;
  }

  get projectNameAndContractPlace() {
    let info = {};

    if (this.contract) {
      if (this.contract.place) {
        info = this.contract.place;
      }

      if (this.contract.project_name) {
        info.name = this.contract.project_name;
      }
    }

    return info;
  }

  get presentLabelsAndTexts() {
    const presentLabelsAndTexts = [];
    if (
      typeof this.crew_members_present !== "undefined" &&
      this.crew_members_present > 0
    ) {
      presentLabelsAndTexts.push({
        label: this.crew_members_present
      });
    }

    if (this.was_leader_present) {
      presentLabelsAndTexts.push({
        label: "Leader:",
        text: this.was_leader_present ? "Y" : "N",
        textIsBold: true
      });
    }

    return {
      labelsAndTexts: presentLabelsAndTexts
    };
  }
}
